import Vue from "vue";
import { mapActions } from "vuex";
import CivicActionCenter from "JS/components/campaign/civicactioncenter/CivicActionCenter.vue";
import store from "Stores/modules/campaign/civicactioncenter/store";
import initializeCssVars from "JS/helpers/civicactioncenter/initializeCssVars";
import router from "JS/routers/civicactioncenter/routes";
import WidgetHelper from "JS/helpers/widgetHelper";
// import { CampaignSettings as Axios } from "Api/public/axios";
import { cloneDeep as _cloneDeep } from "lodash";

import Paths from "Constants/campaign/civicactioncenter/pathNames";
import Routes from "Constants/campaign/civicactioncenter/routeNames";

initializeCssVars().then(() => {
  const widgetHelper = new WidgetHelper();

  // eslint-disable-next-line no-new
  new Vue({
    el: "#p2a-campaign-container",
    router,
    store,
    components: {
      CivicActionCenter
    },
    data() {
      const {
        campaign: appSettings,
        campaignSettings,
        customerSettings,
        customFieldsValues
      } = _cloneDeep(window.P2A);

      return {
        appSettings,
        campaignSettings,
        customerSettings,
        customFieldsValues,
        isWidget: widgetHelper.isWidget(appSettings)
      };
    },
    computed: {
      // Helper variable that lets us determine whether we should redirect the user to the default action;
      // if this returns true, we know that the client 
      isVisitingHomepage() {
        let urlPath = window.location.pathname.split('/');
        if (urlPath.length < 1) { // If there's no additional path, we know that the URL is attempting to access the homepage
          return true;
        }

        // Isolate the ending portion of the URL - we check this for other routes the user might want to visit instead
        let lastSectionOfURLPath = urlPath.pop(); 

        // Loop through the active paths and make sure that the user is not trying to visit a different path
        return [Paths.CANDIDATES, Paths.ELECTED_OFFICIALS, Paths.REGISTER_TO_VOTE, Paths.VOTER_INFORMATION].every(path => path !== lastSectionOfURLPath);
      }
    },
    created() {
      this.setStateFromSettings(this.appSettings);
      this.setStateFromSettings(this.customerSettings);
      this.setStateFromSettings(this.campaignSettings);

      // Load settings value directly from JS value since VueX has not been updated yet
      let actionOrder = this.campaignSettings.cacActionOrder;
      actionOrder.sort((a, b) => a.position - b.position); // Sort the actions to guarantee correct order

      // Determine whether there's an active route we should redirect the user to from the homepage
      let hasDefaultAction = (actionOrder && actionOrder[0].key && (Routes[actionOrder[0].key] !== Routes.REGISTER_TO_VOTE));

      // If we find a valid default action, we redirect the user there
      // Business logic - the Welcome/Home screen prompts the user to register to vote, so if the client 
      // wants the user to register to vote, we keep them on the Welcome/Home screen
      if (hasDefaultAction && this.isVisitingHomepage) {
        // Otherwise, we redirect them to whichever screen the client wants them to visit first
        router.push({
          name: Routes[actionOrder[0].key]
        }, success => {}, error => {});
        // If the user is already visiting the desired page, the router might throw errors about duplicate navigation
      }

      if (this.isWidget) {
        document.body.className += " is-widget";
      }
    },
    methods: {
      ...mapActions({
        setStateFromSettings: "campaign/fromSettings"
      })
    }
  });
});
